import { Indexes } from './types'
import { HeaderMainKeys } from './constants'
import { revertSanitize } from '../sanitizeText'

export function getCorrectValue(value: string): string {
  return replaceNonBreakingSpaceChars(revertSanitize(value?.toString()?.trim())) || ''
}

export function getHeaderMainKeyIndexes(header: string[]): Indexes {
  const { STEP_ID, STEP_TYPE, DIALOG_ID, STEP_VALUE, SUB_STEP_ID, SUB_STEP_TYPE } = HeaderMainKeys

  const stepIdIndex = header.findIndex(cell => cell.trim() === STEP_ID)
  const stepTypeIndex = header.findIndex(cell => cell.trim() === STEP_TYPE)
  const dialogIdIndex = header.findIndex(cell => cell.trim() === DIALOG_ID)
  const stepValueIndex = header.findIndex(cell => cell.trim() === STEP_VALUE)
  const subStepIdIndex = header.findIndex(cell => cell.trim() === SUB_STEP_ID)
  const subStepTypeIndex = header.findIndex(cell => cell.trim() === SUB_STEP_TYPE)

  return {
    stepIdIndex,
    stepTypeIndex,
    dialogIdIndex,
    stepValueIndex,
    subStepIdIndex,
    subStepTypeIndex
  }
}

function replaceNonBreakingSpaceChars(value?: string): string | undefined {
  if (!value) {
    return value
  }

  //this char should be replaced by space for examplce, beacause of failute on jsondispatchdiff FBOT-1031
  return value.replace(/\xa0/g, ' ')
}
